import { RootState } from '@reducers';

export const selectPersonalAccidentPolicyClaim = (state: RootState) =>
  state.userDashboardRouteReducer.policyClaim.personalAccidentPolicyClaim;
